import React, { useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { requestCanceller } from '../../service/axiosCancelToken';
import { getUserOrders } from '../../service/orderService';
import UserOrder from './UserOrder';
import './UserOrders.css';
import socket from '../../service/socket';
import LoadingBar from '../shared/EclipseLoading';
import IconLoading from '../shared/IconLoading';
import { Badge } from 'react-bootstrap';

const UserOrders = () => {
    const [mode, setMode] = useState('Queue')
    const [items, setItems] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [lastItemTime, setLastItemTime] = useState();
    const [hasMore, setHasMore] = useState(true);
    const [countOrders, setCountOrders] = useState({ queue: 0, processing: 0, delivered: 0 })
    const perPage = 18;


    useEffect(() => {

        const cancelRequest = requestCanceller();

        const fetchAllOrders = async () => {
            try {
                const params = { status: mode, lastItemTime: lastItemTime, perPage };
                let { status, data } = await getUserOrders(params, { signal: cancelRequest.signal });
                if (status === 201) {
                    setItems(prev => {
                        if (!prev || !prev.length || (prev.length && lastItemTime <= 1)) {
                            return data.orders;
                        }
                        else {
                            let allitems = prev.concat(data.orders);
                            return allitems;
                        }
                    })
                    if (data.orders.length < perPage) {
                        setHasMore(false);
                    }
                    setCountOrders({ queue: data.countOfQueue, processing: data.countOfProcessing, delivered: data.countOfDelivered })
                    setIsLoading(false);

                }
            } catch (err) {
            }
        }
        fetchAllOrders();
        return () => {
            cancelRequest.cancel();
        }
    }, [mode, lastItemTime]);

    const fetchMoreData = async () => {
        const lastItemTime = items[items.length - 1].createdAt;
        setLastItemTime(lastItemTime);
    };

    const onChangeModeHandler = (event) => {
        setIsLoading(true);
        setItems();
        setHasMore(true);
        setLastItemTime();
        setMode(event.target.value)
    }




    useEffect(() => {
        try {

            socket.on("order", data => {
                if (data.action === 'create') {
                    setCountOrders(prev => ({ ...prev, queue: prev.queue + 1 }))
                    let allItems = [...items]
                    if (!hasMore && mode === 'Queue') {
                        allItems.push(data.createdOrder);
                    }
                    setItems(allItems)
                }
                if (data.action === 'delete') {
                    let allItems = [...items];
                    if (mode === 'Queue') {
                        const findedIndex = allItems.findIndex(item => item._id === data.orderId)
                        if (findedIndex > -1) {
                            const newItems = allItems.filter(item => item._id !== data.orderId);
                            setItems(newItems);
                            setCountOrders(prev => ({ ...prev, queue: prev.queue - 1 }))
                        }
                        else {
                            setCountOrders(prev => ({ ...prev, processing: prev.processing - 1 }))
                        }
                    }
                    else if (mode === 'Processing') {
                        const findedIndex = allItems.findIndex(item => item._id === data.orderId)
                        if (findedIndex > -1) {
                            const newItems = allItems.filter(item => item._id !== data.orderId);
                            setItems(newItems);
                            setCountOrders(prev => ({ ...prev, processing: prev.processing - 1 }))
                        }
                        else {
                            setCountOrders(prev => ({ ...prev, queue: prev.queue - 1 }))
                        }
                    }

                }
                if (data.action === 'confirm') {
                    if (mode === 'Queue') {
                        let allItems = [...items];
                        const newItems = allItems.filter(item => item._id !== data.updatedOrder._id);
                        setItems(newItems);
                    }
                    else if (mode === 'Processing' && !hasMore) {
                        setItems(prev => [...prev, data.updatedOrder])
                    }
                    setCountOrders(prev => ({ processing: prev.processing + 1, queue: prev.queue - 1 }))
                }
                if (data.action === 'deliver') {
                    let allItems = [...items];

                    if (mode === 'Processing') {
                        const newItems = allItems.filter(item => item._id !== data.orderId);
                        setItems(newItems)
                    }

                    setCountOrders(prev => ({ ...prev, processing: prev.processing - 1 }))
                }

                // if (data.action === 'editOrder') {
                //     let allItems = [...items]
                //     let findedIndex = allItems.findIndex(item => item._id === data.updatedOrder._id)
                //     if (findedIndex > -1) {
                //         allItems[findedIndex] = data.updatedOrder;
                //         setItems(allItems);
                //     }
                // }



            });
        } catch (err) {

        }
        return () => {
            socket.off('order');
        }
    }, [items, hasMore, mode]);



    return (
        <div className='user-orders-layer'>
            <header className='w-100'>
                <h6 className=''>
                    <span></span>
                    سفارشات شما
                </h6>
                <div>
                    <select className="form-select" style={{ marginRight: '0', fontSize: '.9rem' }}
                        onChange={onChangeModeHandler}
                    >
                        <option value={'Queue'} label={`تأیید نشده`}></option>
                        <option value={'Processing'} label={`در حال انجام`}></option>
                        <option value={'Delivered'} label={`تحویل شده`}></option>
                    </select>
                </div>
                <h5 className='m-0 h-100'>
                    <Badge bg="danger">
                        {
                            mode === 'Queue' ? countOrders.queue : mode === 'Processing' ? countOrders.processing : countOrders.delivered
                        }
                        <span className='ms-2'>مورد</span>
                    </Badge>
                </h5>
            </header>
            <section>
                <div className='orders-container'>
                    {
                        (!items || !items.length || isLoading) ?
                            <section style={{
                                height: '60vh',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}>
                                {
                                    items && !items.length ?
                                        <p className='text-secondary'>موردی برای نمایش وجود ندارد</p> :
                                        <LoadingBar classNames={`ldio-text-danger`} />
                                }
                            </section>
                            :
                            <InfiniteScroll
                                dataLength={items && items.length}
                                next={fetchMoreData}
                                hasMore={hasMore}
                                loader={
                                    <div className="d-flex flex-column text-center mt-2 mb-5 mb-sm-2 w-100">
                                        <span className="mx-auto">
                                            {
                                                items.length ?
                                                    <IconLoading
                                                        type="spin"
                                                        color={"#777"}
                                                        width={50}
                                                        height={50}
                                                    /> : null
                                            }
                                        </span>
                                    </div>
                                }
                                endMessage={
                                    <p className="end-message-infinite-scroll">
                                    </p>
                                }
                            >
                                {
                                    items.map((item, index) =>
                                        <UserOrder
                                            number={index + 1}
                                            key={item._id}
                                            order={item}
                                        />
                                    )
                                }
                            </InfiniteScroll>
                    }
                </div>

            </section>
        </div>
    );
}

export default UserOrders;